module.exports = __webpack_public_path__ + "img/loading.1d060288.svg";